import { useTranslation } from 'react-i18next';

export const useGetNotificationTextData = () => {
    const { t } = useTranslation();

    return {
        success: {
            titleText: t('contactForm.notification.success.title'),
            descText: t('contactForm.notification.success.desc'),
        },
        error: {
            titleText: t('contactForm.notification.error.title'),
            descText: t('contactForm.notification.error.desc'),
        },
        emailConnectionError: {
            titleText: t('contactForm.notification.emailConnectionError.title'),
            descText: t('contactForm.notification.emailConnectionError.desc'),
        },
    };
};
